<main class="c-main wow-consulta">

    <div class="container-fluid">

        <div class="row">

            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">{{ erro }}</div>

        </div>

        <div class="mat-elevation-z8">

            <mat-card>

                <div class="wow-consulta__header">

                    <div class="wow-consulta__header-icon"><mat-icon>payments</mat-icon></div>

                    <mat-card-title>Contas à Pagar</mat-card-title>

                </div>



                <app-wow-consulta-filtros

                    [tipoFiltros]="tipoFiltros"

                    [(tipoFiltro)]="tipoFiltro"

                    [(parametro)]="parametro"

                    [showParametro]="tipoFiltro === 'ID' || tipoFiltro === 'Favorecido'"

                    [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"

                    [labelParametro]="tipoFiltro === 'Favorecido' ? 'Favorecido' : ''"

                    [layoutInline]="true"

                    (tipoFiltroChange)="onFiltroChange()"

                    (consultar)="consultar()"

                    (novo)="novo()">

                    <div class="wow-consulta__campo">
                        <mat-form-field appearance="fill" class="full-width">
                            <mat-label>Situação</mat-label>
                            <mat-select [(ngModel)]="filtroSituacao" (selectionChange)="onFiltroChange()">
                                <mat-option [value]="null">Todas</mat-option>
                                <mat-option *ngFor="let s of situacoesFiltro" [value]="s.valor">{{ s.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="tipoFiltro !== 'Favorecido' && tipoFiltro !== 'ID'">
                        <div class="wow-consulta__campo">
                            <mat-form-field appearance="fill" class="full-width">
                                <mat-label>Data vencimento início</mat-label>
                                <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="dataInicioFiltro">
                                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
                                <mat-datepicker #pickerInicio></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="wow-consulta__campo">
                            <mat-form-field appearance="fill" class="full-width">
                                <mat-label>Data vencimento fim</mat-label>
                                <input matInput [matDatepicker]="pickerFim" [(ngModel)]="dataFimFiltro">
                                <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
                                <mat-datepicker #pickerFim></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </ng-container>

                </app-wow-consulta-filtros>



                <div class="wow-consulta__empty" *ngIf="!consultaRealizada">

                    Informe os filtros e clique em <strong>Consultar</strong>.

                </div>



                <ng-container *ngIf="consultaRealizada">

                    <table mat-table [dataSource]="contapagar" class="full-width">

                        <ng-container matColumnDef="id">

                            <th mat-header-cell *matHeaderCellDef>ID</th>

                            <td mat-cell *matCellDef="let p">{{ p.id }}</td>

                        </ng-container>

                        <ng-container matColumnDef="favorecido">

                            <th mat-header-cell *matHeaderCellDef>Tipo</th>

                            <td mat-cell *matCellDef="let p">{{ p.favorecido }}</td>

                        </ng-container>

                        <ng-container matColumnDef="favorecidoDescricao">

                            <th mat-header-cell *matHeaderCellDef>Favorecido</th>

                            <td mat-cell *matCellDef="let p">{{ p.favorecidoDescricao }}</td>

                        </ng-container>

                        <ng-container matColumnDef="parcela">

                            <th mat-header-cell *matHeaderCellDef>Parcela</th>

                            <td mat-cell *matCellDef="let p">{{ p.parcela }}</td>

                        </ng-container>

                        <ng-container matColumnDef="total">

                            <th mat-header-cell *matHeaderCellDef>Valor</th>

                            <td mat-cell *matCellDef="let p">{{ p.total | currency:'BRL' }}</td>

                        </ng-container>

                        <ng-container matColumnDef="dtVencimento">

                            <th mat-header-cell *matHeaderCellDef>Vencimento</th>

                            <td mat-cell *matCellDef="let p">{{ p.dtVencimento }}</td>

                        </ng-container>

                        <ng-container matColumnDef="dtPagamento">

                            <th mat-header-cell *matHeaderCellDef>Pagamento</th>

                            <td mat-cell *matCellDef="let p">{{ p.dtPagamento }}</td>

                        </ng-container>

                        <ng-container matColumnDef="pagamento">

                            <th mat-header-cell *matHeaderCellDef>Forma</th>

                            <td mat-cell *matCellDef="let p">{{ p.pagamento }}</td>

                        </ng-container>

                        <ng-container matColumnDef="situacao">

                            <th mat-header-cell *matHeaderCellDef>Situação</th>

                            <td mat-cell *matCellDef="let p">{{ p.situacaoDescricao || p.situacao }}</td>

                        </ng-container>

                        <ng-container matColumnDef="excluir">

                            <th mat-header-cell *matHeaderCellDef></th>

                            <td mat-cell *matCellDef="let p" (click)="$event.stopPropagation()">

                                <button (click)="openDialog(p.id)" mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>

                            </td>

                        </ng-container>

                        <ng-container matColumnDef="editar">

                            <th mat-header-cell *matHeaderCellDef></th>

                            <td mat-cell *matCellDef="let p" (click)="$event.stopPropagation()">

                                <button (click)="editar(p.id)" mat-icon-button color="accent"><mat-icon>edit</mat-icon></button>

                            </td>

                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>

                        <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;" class="wow-consulta__row"
                          (click)="editar(row.id)"></tr>

                    </table>

                    <mat-paginator [length]="totalElementos" [pageSize]="tamanho" [pageSizeOptions]="pageSizeOptions"

                        (page)="paginar($event)"></mat-paginator>

                </ng-container>

            </mat-card>

        </div>

    </div>

</main>

